module.exports = __webpack_public_path__ + "img/upload-01.9260e55c.svg";